import React from 'react';
import type { FC } from 'react';
import { CardStyled, Title } from './ReservationNotesCard.styled';
import { ReservationNoteModel } from '@/models/reservation';

interface Props {
  readonly notes?: ReservationNoteModel[];
}

const ReservationNotesCard : FC<Props> = ({ notes }) => {
  if (notes === undefined || notes.length === 0) {
    return null;
  } else {
    return (
      <CardStyled>
        <Title>
          Reservation notes
        </Title>

        { notes.map(({ id, text }) => (
          <span key={id}>
            { text }
          </span>
        )) }
      </CardStyled>
    );
  }
};

export default ReservationNotesCard;
